'use client';

import Script from 'next/script';

import { type ReactNode, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface GoogleAdSenseProviderProps {
  children?: ReactNode;
}

export const GoogleAdSenseProvider = ({ children }: GoogleAdSenseProviderProps) => {
  useEffect(() => {
    ReactDOM.preconnect('https://pagead2.googlesyndication.com', { crossOrigin: 'anonymous' });
  }, []);

  return (
    <>
      <Script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2964868044958062"
        crossOrigin="anonymous"
      />
      {children}
    </>
  );
};
